import React, { useState } from 'react'
import * as E from '../elementor'
import ArrowIcon from '../images/arrow-narrow-right.svg'
import Modal from './content/modal'
interface Props {
  section?: E.Section
  theme?: string
  responsive?: boolean // Handles the responsive design for the partner logos section
  buttonText?: string | null // Handles the text for the button in the partners section
  template?: string // Special styling applies to specific templates
}

const PartnerBanner: React.FC<Props> = ({ section, theme, responsive = false, buttonText = null, template = '' }) => {
  const [showCompleteListModal, setshowCompleteListModal] = useState(false)
  const { textEditor = [], basicGallery = [], button = [] } = (section != null) ? E.collect(section) : {}

  const modalText = textEditor[3]?.text().split(', ')

  return (
    <div className={`partner-banner ${template === 'provider' ? 'partner-provider' : ''} ${responsive ? 'responsive' : ''}`} data-theme={theme}>
      <div className={`partner-callout ${textEditor[4] !== undefined ? 'tooltip' : null}`}>
        { textEditor[4] !== undefined
        ? <>
            <div className='tooltip-text'>
              <p>{textEditor[4]?.parse()}</p>
            </div>
            <div className='info-icon'>
              <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path id='Icon' d='M6.00001 7.91995V5.99995M6.00001 4.07995H6.00481M10.8 5.99995C10.8 8.65092 8.65098 10.8 6.00001 10.8C3.34905 10.8 1.20001 8.65092 1.20001 5.99995C1.20001 3.34898 3.34905 1.19995 6.00001 1.19995C8.65098 1.19995 10.8 3.34898 10.8 5.99995Z' stroke-width='0.9' stroke-linecap='round' stroke-linejoin='round' />
              </svg>
            </div>
          </>
        : null
        }
        <p className="partner-callout-message">
          {textEditor[0]?.text()}
        </p>
      </div>
      <div className='partner-logos'>
        {basicGallery[0]?.images.map((image, idx) => (
          <img key={idx} src={image.fileUrl} />
        ))}
      </div>
      <div className='logo-link-wrapper'>
        <button className='link-bold' onClick={() => setshowCompleteListModal(true)}>
          <p className={template === 'tofu' ? 'paragraph-small-bold' : 'paragraph-bold'}>{buttonText ? buttonText : 'View more partners'}</p>
          <img className='arrow-icon' src={ArrowIcon} />
        </button>
        {showCompleteListModal &&
          <Modal
            heading={textEditor[1]?.text()}
            subheading={textEditor[2]?.text()}
            headingAlignment='left'
            modalClass='modal-cards'
            showCloseButton={true}
            setDismissalState={setshowCompleteListModal}
            actionButton={button[0]}
            mainContent={
              <>
                {modalText.map((text, idx) => {
                  return <p key={idx} className='modal-cards-copy'>{text}</p>
                })}
              </>
}
          />}
      </div>
    </div>
  )
}

export default PartnerBanner
